const QuickNoteHeader = ({ header, onClose }) => {
  return (
    <div className="d-flex border-bottom px-3 py-2 font-weight-600 text-dark justify-content-between align-items-center">
      {header}
      <i
        className="mdi mdi-close cursor-pointer"
        style={{ fontSize: 22 }}
        onClick={onClose}
      />
    </div>
  );
};

export default QuickNoteHeader;
